import _ from "lodash";
import tree from "../../state";
import { showError } from "../../actions/alertActions";
import * as playerActions from "../../actions/playerActions";
import * as actionsTimerManager from "../../actions/actionsTimerManager";
import PlayerPaths from "../../constants/paths/playerPaths";
import env from "../../constants/env";
import config from "../../config/config";
import * as awsS3 from "../s3";
import { normalizeActivity, getActivityLastUpdatedDateTime, createActivitySessionListItem, getExtension } from "../../utils/utils";
import moment from "moment";

let publishMode = false;

function getUtcTimestamp() {
	// ISO 8601
	return moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
}

export default class PersistenceManagerAmbifi {

	async init(params) {
		console.log("Initialize persistence manager AmbiFi", params);
		tree.set(PlayerPaths.ACTIVITIES, params.activities);

		let sessionFound = false;

		// This is now considering the alternative publish load which can take advantage of this persistence manager
		let activityId, activityIdentityId, activityInstanceId;


		if (params.activities && (!params.activityId || _.isEmpty(params.activityId))) {
			const targetActivity = _.first(params.activities);
			activityId = targetActivity.id;
			publishMode = true;
			tree.set(PlayerPaths.ACTIVITIES, params.activities);
		} else {
			activityId = params.activityId;
		}
		activityIdentityId = params.activityIdentityId;
		activityInstanceId = params.activityInstanceId;

		//look up URL from sessions
		let sessions = tree.get(PlayerPaths.SESSIONS_BY_ACTIVITY_ID(activityId));
		if (!sessions) {
			sessions = tree.get(["player", "statusDetailSessions"]);
		}
		console.log("Find session", activityId, sessions, tree.get());
		if (!_.isUndefined(sessions) && sessions) {
			let index = _.findIndex(sessions, { id: activityId, instanceId: activityInstanceId });
			if (index !== -1) {
				sessionFound = true;
			}
		}

		let promise;

		if (sessionFound) {
			promise = this.resumeActivity(tree, activityId, activityInstanceId, null, activityIdentityId);
		} else {
			promise = this.startNewActivity(tree, activityId, activityInstanceId, null);
		}

		return promise;
	}

	async printInstance(name, data, templateId) {
		if (!_.isUndefined(_.get(config, "persistence.printTemplate"))) {

			const res = await config.persistence.printTemplate(name, data, templateId, {});
			return res;
		} else {
			return Promise.resolve();
		}
	}

	async save(params = {}) {
		const { submit, submitted, overrides } = params;
		let activity = tree.get(PlayerPaths.ACTIVITY);
		if (submit) {
			activity.submitted = submitted;
		}
		return this.saveHistoryInstances([activity], overrides);
	}

	async saveAndExit(submit=false) {
		let self = this;
		return new Promise((resolve, reject) => {
			const submitted = getUtcTimestamp();
			const submitInfo = { submit, submitted };
			// console.log("SAVE AND EXIT (PersistenceManager AmbiFI)", submitInfo, submit);
			self.save(submitInfo).then(() => {

				let activity = tree.get(PlayerPaths.ACTIVITY);

				if (activity.history.length > 0) {
					//update session data
					let activityId = activity.id;
					let activitySessions = tree.get(PlayerPaths.SESSIONS_BY_ACTIVITY_ID(activityId));
					let idx = _.findIndex(activitySessions, { instanceId: activity.instanceId });

					if (idx > -1) {
						//update existing session
						let lastUpdatedDateTime = getActivityLastUpdatedDateTime(activity);
						tree.set(PlayerPaths.SESSION_LAST_UPDATED_DATE_TIME(activityId, idx), lastUpdatedDateTime);
						if (submit) {
							// console.log("SUBMITTED", submitInfo);
							tree.set(PlayerPaths.SESSION_SUBMITTED(activityId, idx), submitted);
						}
					} else {
						let sessions = tree.get(PlayerPaths.SESSIONS_BY_ACTIVITY_ID(activityId));
						if (_.isUndefined(sessions)) {
							tree.set(PlayerPaths.SESSIONS_BY_ACTIVITY_ID(activityId), []);
						}
						tree.unshift(PlayerPaths.SESSIONS_BY_ACTIVITY_ID(activityId), createActivitySessionListItem(activity, submitInfo));
					}
				}

				let event = {
					activity,
					sessions: tree.get(PlayerPaths.SESSIONS),
					submitInfo
				};
				resolve(event);
			}).catch((err) => {
				reject(err);
			});
		});
	}

	async saveResponse() {
		// console.log("Save response!");
	}

	restoreActivityResponsesAndState(activity) {
		// console.log("Restore activity responses and state!");
		return activity;
	}

	async setCompletionState(completionState) {
		// console.log("Set completion state to " + completionState);
	}

	async trackHistory(historyItem) {
		// console.log("Track history item", historyItem);
	}

	async loadActivity(activityId, initialItemId, newSession = false) {
		let sessions = tree.get(PlayerPaths.SESSIONS_BY_ACTIVITY_ID(activityId));

		let promise;

		if (!_.isUndefined(sessions) && sessions.length > 0 && newSession === false) {
			promise = this.resumeActivity(tree, activityId, sessions[0].instanceId, initialItemId);
		} else {
			promise = this.startNewActivity(tree, activityId, null, initialItemId);
		}
		return promise;
	}

	async resumeActivity(tree, activityId, activityInstanceId, initialItemId, activityIdentityId) {
		let self = this;
		let url;
		//look up URL from sessions
		let sessions = tree.get(PlayerPaths.SESSIONS_BY_ACTIVITY_ID(activityId));
		if (!_.isUndefined(sessions)) {
			let index = _.findIndex(sessions, { id: activityId, instanceId: activityInstanceId });
			if (index !== -1) {
				url = sessions[index].url;
			}
		}

		if (url !== null) {

			return awsS3.loadActivityInstanceFromS3(env.s3.contentBucket, url).then(async (result) => {		
				await self.loadTimerTemplates(tree);
				actionsTimerManager.deleteAllTimers(tree);
				await playerActions.initializeActivity(tree, result, initialItemId);			
				tree.set(PlayerPaths.SHOW_SPINNER, false);
				tree.set(PlayerPaths.SELECTED_ACTIVITY_IDENTITY_ID, activityIdentityId);
			}).catch((err) => {
				tree.set(PlayerPaths.SHOW_SPINNER, false);
				showError("Unable to resume activity", err);
			});
		} else {
			return Promise.resolve({});
		}
	}

	async startNewActivity(tree, activityId, activityInstanceId = null, initialItemId = null) {
		let self = this;

		const playerActivities = tree.get(PlayerPaths.ACTIVITIES);
		console.log("Start new activity", playerActivities);
		tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, activityId);

		let identityId = "";
		let activity = null;
		for (let i = 0; i < playerActivities.length; i++) {
			const playerActivity = playerActivities[i];

			if (playerActivity.id === activityId) {
				identityId = playerActivity.identityId;
				activity = playerActivity;
			}
		}

		if (publishMode && activity && activity.hasOwnProperty("children") && _.isArray(activity.children)) {
			// // console.log("DONT LOAD ACTIVITY", activity);
			const normalizedActivity = normalizeActivity(activity);
			await playerActions.initializeActivity(tree, normalizedActivity, initialItemId);
			tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, activityId);

			if (activityInstanceId !== null) {
				tree.set(PlayerPaths.ACTIVITY_PROPERTY("instanceId"), activityInstanceId);
			}

			let instance = tree.get(PlayerPaths.ACTIVITY);

			if (instance) {
				tree.set(PlayerPaths.SELECTED_ACTIVITY_INSTANCE_ID, instance.instanceId);
				tree.set(PlayerPaths.SHOW_SPINNER, false);
			}

			return normalizedActivity;
		} else {
			// // console.log("GET ACTIVITY", activityId);
			//need to get activity template and inject content	
      
        	let prefix = identityId;
			if (activity && activity.fetchPublication) {
				const selectedOrg = tree.get(["selectedOrg"]);
				console.log("Need to fetch publication", selectedOrg, activity);
				if (selectedOrg && selectedOrg.id) {
					prefix = `${selectedOrg.id}/publications/${activity.id}/${activity.publicationVersion}`;
				}
			}
      
			return new Promise((res, rej) => {
				awsS3.getActivity(activityId, prefix, activityInstanceId).then(async (activityResult) => {
					await self.loadTimerTemplates(tree);
					actionsTimerManager.deleteAllTimers(tree);
					const activity = normalizeActivity(activityResult);
					await playerActions.initializeActivity(tree, activity, initialItemId);
					tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, activityId);

					if (activityInstanceId !== null) {
						tree.set(PlayerPaths.ACTIVITY_PROPERTY("instanceId"), activityInstanceId);
					}

					let instance = tree.get(PlayerPaths.ACTIVITY);

					if (instance) {
						tree.set(PlayerPaths.SELECTED_ACTIVITY_INSTANCE_ID, instance.instanceId);
						tree.set(PlayerPaths.SHOW_SPINNER, false);
					}
					res(activity);
				}).catch((err) => {
					console.error(err);
					showError("Unable to start new activity", err);
					rej(err);
					});
			});
		}
		
	}

	async saveHistoryInstances(obj, overrides = {}, refreshActivities = false) {
		// Array of instances to save to s3

		let instances = obj;
		let files = [];
		let errLog = [];

		let displayName = null;

		if (overrides.displayName) {
			displayName = overrides.displayName;
		} else {
			const member = tree.get(["selectedOrg", "member"]);
			if (member) {
				displayName = member.displayName;
			}
		}

		for (let i = 0; i < instances.length; i++) {
			//alert("Error " + i);
			try {
				let instance = instances[i];
				let lastTimestamp = (instance.history[0].timestamp).replace(" ", "T");
				let fileName = instance.id + "/" + lastTimestamp + "_" + instance.instanceId + ".json";
				instance.displayName = displayName;

				files.push({ fileName: fileName, fileContent: instance });
			} catch (e) {
				console.error(e);
				errLog.push(e);
			}
		}

		if (errLog.length > 0) {
			//alert(JSON.stringify(errLog, null, 2));
		}

		return awsS3.saveHistory(env.s3.contentBucket, files, overrides.keyPrefixOverride, refreshActivities);
	}

	async uploadMediaFile(fileData, fileName, targetType, identityId) {

		return new Promise((resolve, reject) => {
			awsS3.uploadMediaFileToS3(env.s3.userUploadBucket, fileData, identityId + "_" + fileName, targetType).then(() => {

				let ext = getExtension(fileName);
				let newExt;

				if (targetType === "video") {
					newExt = "mp4";
				} else {
					newExt = ext;
				}

				let fileNameNoExt = fileName.split(".").slice(0, -1).join(".");

				const key = `${identityId}/userAssets/${targetType}/${fileNameNoExt}.${newExt}`;
				const bucket = env.s3.contentBucket;

				awsS3.waitForKeyExists(bucket, key).then(() => {
					// console.log("Found it!");
					resolve({ url: `https://s3.amazonaws.com/${bucket}/${key}` });
				}).catch(err => {
					console.error("Doesn't exist yet", err);
					reject(err);
				});
			}).catch(err => {
				console.error(err);
				reject(err);
			});
		});
	}

	async loadTimerTemplates(tree) {		
		let timerTemplates = await awsS3.loadTimerTemplatesFromS3();		
		tree.set(["timerTemplates"], timerTemplates);		
	}
}
